import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ViewNotificationReceipt } from '../../types/notification-receipt.types';

@Component({
  selector: 'studio-notification-receipt',
  templateUrl: './notification-receipt.component.html',
  styleUrls: ['./notification-receipt.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationReceiptComponent {
  @Input() receipt: ViewNotificationReceipt;
  @Output() clicked = new EventEmitter();
  public isFullInfo = false;
  public isEllipsisActive = false;

  showFullInfo() {
    this.isFullInfo = !this.isFullInfo;
  }
}
